/**
 * Socket.io room segment for platform-scoped Signal Providers (no tenant JWT claim).
 * Must match platform MS bell publish fallback (`sp-rewards.controller` redeem path).
 */
export const SP_GLOBAL_BELL_SUBDOMAIN = 'global'

/**
 * Subdomain sent in Socket.io handshake auth — determines `provider:{subdomain}:{userId}` room.
 */
export function resolveSpNotificationSubdomain(
  userSubdomain: string | null | undefined,
): string {
  const fromSession = userSubdomain?.trim()
  if (fromSession) return fromSession
  return SP_GLOBAL_BELL_SUBDOMAIN
}
